const binding = { modules: {}, dataActions: {} };

    (binding.modules['herbal-text-block-video'] = {
        c: () => require('partner/modules/herbal-text-block-video/herbal-text-block-video.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'herbal-text-block-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/herbal-text-block-video'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|herbal-text-block-video|herbal-text-block-video'] = {
                c: () => require('partner/modules/herbal-text-block-video/herbal-text-block-video.view.tsx'),
                cn: '__local__-__local__-herbal-text-block-video'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };